module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-week-fill-9b66e31b.svg";